import React from 'react'
import Button from 'react-bootstrap/Button';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

const ExportCSV = ({ disabled, csvData, fileName, isTransaction = false }) => {
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
    const fileExtension = '.xlsx';

    const exportToCSV = (csvData, fileName) => {
        console.log("exportToCSV")
        console.log(isTransaction)
        console.log(csvData)
        if (isTransaction === true) {
            const wb = { Sheets: { }, SheetNames: [] }
            csvData.forEach(x => {
                const ws = XLSX.utils.json_to_sheet((x))
                const sizeCat = x[0]['Größenkategorie']
                wb.SheetNames.push(sizeCat)
                wb.Sheets[sizeCat] = ws
            })
            const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
            const data = new Blob([excelBuffer], { type: fileType })
            FileSaver.saveAs(data, fileName + fileExtension)
        } else {
            const ws = XLSX.utils.json_to_sheet((csvData))
            const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] }
            const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
            const data = new Blob([excelBuffer], { type: fileType })
            FileSaver.saveAs(data, fileName + fileExtension)
        }
    }

    return (
        <Button lang="de" className="searchBar exportButton" disabled={disabled} variant="secondary" onClick={(e) => exportToCSV(csvData, fileName)}>Export</Button>
    )
}

export { ExportCSV }